// AI Generated Module
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ApiUsersFormComponent } from './forms/api-users-form.component';
import { ApiUsersDashboardComponent } from './pages/api-users-dashboard.component';
import { ApiUsersService } from './services/api-users.service';
import { ApiUsersRoutingModule } from './api-users-routing.module';
import { SharedModule } from '@client/ng2/shared/shared.module';
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { LayoutModule, TableModule } from '@monsido/angular-shared-components';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        ApiUsersFormComponent,
        ApiUsersDashboardComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        ApiUsersRoutingModule,
        SharedModule,
        ComponentsModule,
        UpgradePipeModule,
        TranslateModule,
        TableModule,
        LayoutModule,
        ModalsDirectivesModule,
    ],
    providers: [
        ApiUsersService,
    ],
    exports: [
        ApiUsersFormComponent,
        ApiUsersDashboardComponent,
    ],
})
export class ApiUsersModule {}
